import React from 'react';

import CSSModules from 'react-css-modules';

import FixedRatioImage from '../../FixedRatioImage';
import Heading from '../../TextComponents/Heading';
import {createMarkup} from '../../utils/markdownUtils';

import styles from './styles.module.scss';

type IntroProps = {
  courseColour: string;
  greeting?: string;
  greetingPlaceholder?: string;
  description?: string;
  descriptionPlaceholder?: string;
  imageUrl?: string;
  hovered: boolean;
  reskinClassName?: string;
};

const Intro = ({
  greeting,
  greetingPlaceholder,
  description,
  descriptionPlaceholder,
  imageUrl,
  courseColour,
  hovered,
  reskinClassName = '',
}: IntroProps): JSX.Element => (
  <div styleName={reskinClassName}>
    <div styleName={'imageContainer' + (hovered ? ' hovered' : '')}>
      <FixedRatioImage
        backgroundColor={courseColour}
        url={imageUrl}
        dataAutomation='component-image'
      />
    </div>

    <div>
      <div styleName='introTitle'>
        <Heading
          size='cat'
          as='h2'
          weight='medium'
          colour={greeting ? 'textPrimary' : 'grey300'}
          dataAutomation='component-title'
        >
          {greeting || greetingPlaceholder || ''}
        </Heading>
      </div>
      <div
        styleName={`introBody ${!description ? 'grey' : ''}`}
        data-automation='component-description'
      >
        <div
          dangerouslySetInnerHTML={createMarkup(
            description || descriptionPlaceholder || ''
          )}
        />
      </div>
    </div>
  </div>
);

export default CSSModules(Intro, styles, {allowMultiple: true});
